import React, { useContext } from "react";
import { Row, Empty } from "antd";
import ModuleCard from "./ModuleCard";
import { AuthContext } from "../../../services/authcontext";

export default function ModuleGrid({
  modules,
  statuses,
  titleMapping,
  loading,
  initialLoading,
  onCreate,
  onToggle,
  onDelete,
  isBackendDown,
}) {
  // 2. Add this condition
  if (!modules || modules.length === 0) {
    return (
      <Empty
        description="You don't have access to any modules in this category."
        style={{ margin: "40px auto" }}
      />
    );
  }

  const { user } = useContext(AuthContext);
  const isRoleUser =
    user?.roles?.some((role) => role.name === "ROLE_USER") ?? false;

  return (
    <Row gutter={[16, 16]}>
      {modules.map((module) => {
        const mappedTitle = titleMapping ? titleMapping[module.id] : module.id;

        return (
          <ModuleCard
            key={module.id}
            module={module}
            currentStatus={statuses[mappedTitle]}
            isActionLoading={loading[mappedTitle] || false}
            isInitialLoading={initialLoading}
            onCreate={onCreate}
            onToggle={onToggle}
            onDelete={onDelete}
            isBackendDown={isBackendDown}
            isRoleUser={isRoleUser}
          />
        );
      })}
    </Row>
  );
}
